import { Billingdata } from "./billingdata";

export class Hub {
  uuid: string;
  name: string;
  cif: string;
  address: string;
  city: string;
  province?: string;
  postalCode: string;
  country: string;
  email: string;
  contactEmail: string;
  type: "HUB";
  billingData: Billingdata;
  cardData: any;
  bookedWithoutCard?: boolean;
  discount: string;
  flightDiscount?: string;
  image?: string;
  accessType?: "hub";
}
